import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=27b88984&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=ts&"
export * from "./Download.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b88984",
  null
  
)

export default component.exports